import { UseQueryOptions } from "react-query";

export const defaultQueryOptions = <TData, TError = unknown>(options?: UseQueryOptions<TData, TError, TData>) => ({
	staleTime: 3600 * 1000, // 1h
	retry: false,
	...options,
});
